module.exports = __webpack_public_path__ + "img/60_8.7a78f647.png";